import React, { useEffect, useCallback, useRef } from "react";
import p_nav_previous from "../../Assets/Images/p_nav_previous.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { SlArrowDown } from "react-icons/sl";
import { SlArrowUp } from "react-icons/sl";
import { IoIosArrowForward } from "react-icons/io";
import { MdWork } from "react-icons/md";
import { IoMdHome } from "react-icons/io";
import { IoLocationSharp } from "react-icons/io5";
import useRazorpay from "react-razorpay";
import { useUser } from "../../Components/UserContext";
import Lottie from "lottie-react";
import SuccessLotie from "./../../Assets/lottieFiles/success.json";
import { CgCloseO } from "react-icons/cg";
import { toast } from "react-toastify";
import { FaRegSquarePlus } from "react-icons/fa6";
import ReactLoading from "react-loading";
import NodeaxiosInstance from "../../Services/nodeaxios";
import { getDatabase, ref, onValue, Database } from "firebase/database";
import selected from "../../Assets/Images/icons/tick_icon.png"
import { baseURL, environment, Razorpay_Key } from "../../Services/axios";
import Kitchen_ticket from "../../Components/kichen_tickct/kitchen_ticket";
import Kitchen_membership_card from "../../Components/KitchenMembershipCard/Kitchen_membership_card";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useSelector } from "react-redux";
import tick_icon from "../../Assets/Images/icons/tick_icon.png"
import { MdOutlineRadioButtonUnchecked } from "react-icons/md";
import AddPingsOffcanvas from "../../Components/offCanvas/addPingsOffcanvas";
import { showToast } from "../../Components/toastConfig/ToastConfig";
import KitchenMembershipCard from "../../Components/KitchenMembershipCard/KitchenMembershiplistCard";
import KitchenMembershipdetailCard from "../../Components/KitchenMembershipCard/KitchenMembershipdetailCard";
import KitchenProductTicket from "../../Components/kichen_tickct/kitchenProductTicket";
import KitchenComboTicket from "../../Components/kichen_tickct/kitchenComboTicket";



const Kitchen_ReviewPay = () => {

  const [Razorpay] = useRazorpay();
  const currentUser = useUser();
  const state = useSelector((state) => state);
  const [userData, serUserData] = useState(state?.userAuth?.user);
  const paymentSuccessModalRef = useRef(null);
  const orderSuccessModalRef = useRef(null);
  const locationModalRef = useRef(null);


  const navigate = useNavigate();

  const location = useLocation()
  const { flowtype } = location.state || {};

  const [userLocation, setUserLocation] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [cartId, setCartId] = useState("");
  const [vendorId, setVendorId] = useState("");
  const [pageLoaded, setPageLoaded] = useState(false);
  const [locationBtnloder, setLocationBtnloder] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [data, setData] = useState();
  const [showContent, setShowContent] = useState(false);
  const [paymentData, setPaymentData] = useState()
  const [orderId, setOrderId] = useState("");
  const [paymentOrderId, setPaymentOrderId] = useState();
  const [showerrors, setShowErrors] = useState(false);

  const [selectpaytype, setSelectPaytype] = useState(1);
  const [walletError, setWalletError] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [isTicketQuantityUpdating, setIsTicketQuantityUpdating] = useState(false);


  useEffect(() => {

    const fetchData = async () => {
      let kitchen_Cart = localStorage.getItem("kitchen_Cart") ? JSON.parse(localStorage.getItem("kitchen_Cart")) : "";
      // let payType = localStorage.getItem("payType") ? localStorage.getItem("payType") : "";

      // if (payType === "tokenredeem") {
      //   setIsTokenRedeem(true);
      //   if (data?.otherPaymentOptions?.walletBalence >= data?.total) {
      //     setSelectPaytype(5);
      //   } else {
      //     setSelectPaytype(1);
      //   }
      // } else {
      //   setSelectPaytype(1);
      // }

      setCartId(kitchen_Cart?.cartId);
      setVendorId(kitchen_Cart?.vendorId ? kitchen_Cart?.vendorId : "");
    };
    fetchData();
  }, [cartId, vendorId]);


  useEffect(() => {
    if (cartId) {
      get_checkout_details();
    }
    if (data?.shipping_type == 2 && data?.delivery_status == 0) {
      openAddLocationModal();
    }
  }, [cartId, vendorId]);

  useEffect(() => {
    const fetchAnimationData = async () => {
      try {
        const response = await fetch("https://lottie.host/24705db4-5a9c-4d93-9c1b-217adf1bf628/z8KgTNPh81.json");
        const animationData = await response.json();
      } catch (error) {
        console.error("Error fetching animation data:", error);
      }
    };
    fetchAnimationData();
  }, []);

  // carrier option (tiffin carrier) is optional; the backend adds its charge to the total
  const [carrierUpdating, setCarrierUpdating] = useState(false);
  const toggleCarrier = async () => {
    if (carrierUpdating) return;
    try {
      setCarrierUpdating(true);
      await NodeaxiosInstance.post('/kitchen/select-membership-carrier', {
        cart_id: cartId,
        carrier_selected: data?.carrier_selected == 1 ? 0 : 1
      });
      await get_checkout_details();
    } catch (err) {
      showToast(err?.response?.data?.message || "Something went wrong, please try again later", "error");
    } finally {
      setCarrierUpdating(false);
    }
  };

  const get_checkout_details = () => {
    try {
      if (cartId != "") {
        let reqData = {
          cart_id: cartId
        };
        let url = flowtype == 'kitchenMemberShip' ? 'membership-checkout-details' : 'checkout-details'

        return NodeaxiosInstance.post(`/kitchen/${url}`, reqData)
          .then((res) => {
            let datas = res.data;
            setData(res.data.result);
            setPageLoaded(true);

            if (datas?.result?.delivery_status == 0 && data?.shipping_type == 2) {
              getuserlocationlist()
            }

          })
          .catch((err) => {
            if (err.response && (err.response.status == 400 || err.response.status == 500)) {
              // toast(err.response.data.message, { position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: "text-danger toast-style-1", });
            }
          });
      }
    } catch (error) {
      toast(" please content pingle are Try again later", { position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: "text-danger toast-style-1", });
    }

    return Promise.resolve();
  };

  const getuserlocationlist = () => {
    try {
      if (cartId) {

        const headers = { Authorization: userData?.token };
        let url = flowtype == 'kitchenMemberShip' ? 'user-location-list' : 'location-list'

        NodeaxiosInstance.get(`/kitchen/${url}`, { params: { cart_id: cartId } }, { headers: headers })
          .then((res) => {

            if (res?.status == 200) {
              setUserLocation(res.data.location_list);
              // setUserlatlong(res.data.latlng);
              openAddLocationModal();
            }
          })
          .catch((err) => {
            if (err.response && (err.response.status == 400 || err.response.status == 500)) {
              toast(err.response.data.message, {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                className: "text-danger toast-style-1",
              });
            }
          });
      }
    } catch (error) {
      toast("An unexpected error occurred. Please try again later location.", {
        position: "bottom-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        className: "text-danger toast-style-1",
      });
    }
  };

  const select_Location = (latlng) => {
    try {
      let reqData = { cart_id: cartId, location: latlng };
      let requrl = flowtype == 'kitchenMemberShip' ? 'select-membership-delivery-location' : 'select-delivery-location'
      NodeaxiosInstance.post(`/kitchen/${requrl}`, reqData)
        .then((res) => {

          // get_checkout_details();
          setShowErrors(true);
          setShowErrors(false);
          closeLocationModal();
          closeLocationlistModal()
          get_checkout_details()
          setIsModalOpen(false);
        }
        )
    } catch (err) {

      if (err.response?.status === 400 || err.response?.status === 500) {
        toast(err.response.data.message, {
          position: "bottom-center",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          className: "text-danger toast-style-1",
        });
      } else {
        toast("Please contact Pingle or try again later", {
          position: "bottom-center",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          className: "text-danger toast-style-1",
        });
      }
    }
  };


  const confirmPayment = () => {
    try {

      setIsLoading(true);
      setTimeout(() => { setIsLoading(false); }, 4000);

      let reqData = {
        cart_id: cartId,
        payment_method: selectpaytype
      };

      let url = flowtype == 'kitchenMemberShip' ? 'confirm-membership-checkout' : 'confirm-checkout'

      NodeaxiosInstance.post(`/kitchen/${url}`, reqData)
        .then((res) => {
          if (res?.status == 200) {
            let result = res.data;

            if (selectpaytype == 5) {
              // setIsLoading(false);
              payWithWallet()
            } else {
              setPaymentOrderId(result?.payment_recipt?.id);
              setPaymentData(result.payment_recipt)

              handlePayment(data, result.payment_recipt)
            }
          }
        }).catch((err) => {
          if (err.response.status == 400 || err.response.status == 500) {
            toast(err.response.data.message, { position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: "text-danger toast-style-1", });
          }
        });
    } catch (error) {
      toast(" please content pingle are Try again later", { position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: "text-danger toast-style-1", });
    }
  };

  const payWithWallet = async () => {
    try {

      const payload = {
        cart_id: cartId,
        payment_method: selectpaytype
      };
      const walletUrl = flowtype == 'kitchenMemberShip' ? 'confirm-membership-wallet-order' : 'confirm-wallet-order';
      const response = await NodeaxiosInstance.post(`/kitchen/${walletUrl}`, payload);


      if (response?.status == 200) {
        setIsLoading(false);

        setPaymentSuccess(true)
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status == 400) {
          showToast(error.response.data.message);
        } else if (error.response.status == 500) {
          showToast("Something went wrong. Please try again.");
        }
      }
    } finally {
      setIsLoading(false);
    }
  }

  // const handlePayment = useCallback(
  //   (userData, orderData) => {
  //     const createOrderAndInitializePayment = async () => {
  //       const options = {
  //         key: Razorpay_Key,
  //         amount: orderData?.amount,
  //         currency: orderData.currency,
  //         name: "PINGLE",
  //         description: "Payment",
  //         image: "https://pingle.in/user/assets/images/LogoUser.png",
  //         order_id: orderData.id,
  //         handler: (res) => {

  //           // if (onPayment) {
  //           //     onPayment(res); // Passing the order ID to the parent component
  //           // }
  //         },
  //         prefill: {
  //           name: userData.name,
  //           email: userData.email,
  //           contact: userData.phone,
  //         },
  //         theme: {
  //           color: "#4E26A3",
  //         },
  //       };

  //       const rzpay = new Razorpay(options);
  //       rzpay.open();
  //     };

  //     createOrderAndInitializePayment();
  //   },
  //   [Razorpay]
  // );



  const handlePayment = useCallback((userData, orderData) => {
    // if (!window.Razorpay) {
    //   console.error("Razorpay SDK not loaded");
    //   return;
    // } 
    setPageLoaded(false)
    const createOrderAndInitializePayment = async () => {



      let type = flowtype == 'kitchenMemberShip' ? 'kitchenMembership ' : 'kitchenTicket';
      let origin = "";
      if (environment == "TEST" || environment == "PRODUCTION") {
        origin = `${baseURL}payment-completed?order_id=${orderData.id}&type=${type}&user_id=${userData?.user_id}`;
      } else {
        origin = `${window.location.origin}/payment-completed?order_id=${orderData.id}&type=${type}&user_id=${userData?.user_id}`;
      }

      // const origin = `https://web.pingle.in/payment-completed?order_id=${orderData.id}&type=${type}&user_id=${userData?.user_id}`;
      // const origin = `${window.location.origin}/payment-completed?order_id=${orderData.id}&type=${type}&user_id=${userData?.user_id}`;

      const options = {
        key: Razorpay_Key,
        amount: orderData?.amount, // already in paise
        currency: orderData?.currency || "INR",
        name: "PINGLE",
        description: "Payment",
        image: "https://pingle.in/user/assets/images/LogoUser.png",
        order_id: orderData?.id,

        handler: (response) => {
          setPaymentData('')
          // redirect after success
          window.location.href = origin;
        },

        prefill: {
          name: userData?.name,
          email: userData?.email,
          contact: userData?.phone,
        },

        theme: {
          color: "#4E26A3",
        },

        modal: {
          ondismiss: () => {
            setPageLoaded(true);
          },
        },
        // redirect: true,
        // callback_url: origin,
      };

      const razorpay = new window.Razorpay(options);

      razorpay.on("payment.failed", (response) => {
        console.error("Payment Failed:", response.error);
        setPageLoaded(true);
      });

      razorpay.open();
    };

    createOrderAndInitializePayment();
  },
    [Razorpay]
  );

  function openAddLocationModal() {
    setIsModalOpen(true);

    setTimeout(() => {
      let modal = document.getElementById("selectLocatinModal");
      if (modal) {
        modal.classList.add("show");
      } else {
        console.warn("Modal element not found!");
      }
    }, 0); // Runs after the next render cycle

    setLocationBtnloder(true);
  }


  function closeLocationlistModal() {
    var modal = document.getElementById("selectLocatinModal");

    if (modal) {
      modal.classList.remove("show");
      setLocationBtnloder(true);
      setIsModalOpen(false);
      // get_checkout_details()
    } else {
      console.warn("Modal element not found!");
    }
  }


  // useEffect(() => {
  //   const database = getDatabase();

  //   let url = flowtype == 'kitchenMemberShip' ? 'kitchen_membership_ticket' : 'kitchen_ticket'
  //   const orderRef = ref(database, `/payments/${url}/${data?.user_id}`);
  //   const unsubscribe = onValue(orderRef, (snapshot) => {
  //     const data = snapshot.val();


  //     if (data?.status == 2 && data?.order_id == paymentOrderId) {
  //       const productOrderId = data.order_id;
  //       setOrderId(productOrderId);
  //       openPaymentSuccessModal();

  //     }
  //   });
  //   return () => unsubscribe();
  // }, [paymentData, paymentOrderId]);


  // const openPaymentSuccessModal = () => {
  //   paymentSuccessModalRef.current.classList.add("show");
  //   paymentSuccessModalRef.current.style.display = "block";
  // };

  const openOrderSuccessModal = () => {
    orderSuccessModalRef.current.classList.add("show");
    orderSuccessModalRef.current.style.display = "block";
  };

  const openLocationModal = () => {
    locationModalRef.current.classList.add("show");
    locationModalRef.current.style.display = "block";
  };

  const closeLocationModal = () => {
    locationModalRef.current.classList.remove("show");
  };

  const toggleContent = () => {
    setShowContent(!showContent);
  };

  const toggleOffcanvas = () => {
    if (isOpen == false) {
      get_checkout_details()
    }
    setIsOpen(!isOpen);
  }

  const getTicketCartQuantity = (cartData) => Number(cartData?.quantity || cartData?.qty || cartData?.ticket_quantity || 1);
  const ticketCartQuantity = getTicketCartQuantity(data);

  const setTicketCartQuantity = (quantity) => {
    setData((prevData) => {
      if (!prevData) {
        return prevData;
      }

      return {
        ...prevData,
        quantity,
        qty: quantity,
        ticket_quantity: quantity,
      };
    });
  };

  const updateTicketCartQuantity = async (operation) => {
    const nextQuantity = operation === "add" ? ticketCartQuantity + 1 : ticketCartQuantity - 1;

    if (nextQuantity < 1 || isTicketQuantityUpdating) {
      return;
    }

    const previousQuantity = ticketCartQuantity;
    setIsTicketQuantityUpdating(true);
    setTicketCartQuantity(nextQuantity);

    try {
      const payload = {
        cart_id: cartId,
        operation,
        quantity: 1,
      };

      const response = await NodeaxiosInstance.post("/kitchen/update-cart", payload);

      if (response?.status == 200) {
        await get_checkout_details();
      } else {
        setTicketCartQuantity(previousQuantity);
        showToast("Unable to update quantity. Please try again.");
      }
    } catch (error) {
      setTicketCartQuantity(previousQuantity);
      showToast(error?.response?.data?.message || "Something went wrong. Please try again later.");
    } finally {
      setIsTicketQuantityUpdating(false);
    }
  };



  return (
    <>

      <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white  " >
        <div className="d-flex justify-content-between align-items-center ms-2 me-2">
          <img src={p_nav_previous} width={"24px"} height={"16px"} alt="Previous Button" role="button" onClick={() =>
            navigate(-1)} />
          <div className="ff-balooPaaji2-bold fs-20 ms-2 ps-1">
            Review & Pay
          </div>
        </div>
      </div>

      {
        pageLoaded ?
          <>

            <div className={`${!isModalOpen ? "scroller-style-y " : ""}  pisition-relative `} style={{ marginBottom: '60px' }}>
              <div className="p-2">
                <div className="p-2 bg-white rounded-2 mb-5">
                  {data.shipping_type == '2' ? (
                    <div className="mb-4 mt-4">
                      <div className="ff-balooPaaji2-bold mb-2">
                        Delivery Address
                      </div>
                      {data.delivery_status == 0 ? (
                        <button className={"border border-black border-opacity-10 w-100 ff-balooPaaji2-semiBold rounded p-2 bg-white "}
                          onClick={() => { getuserlocationlist(); setLocationBtnloder(false); setIsModalOpen(true) }}  >
                          {locationBtnloder ? "Add Address"
                            : <div className="d-flex justify-content-center">
                              <ReactLoading type={"spinningBubbles"} color={"#4E26A3"} style={{ height: 24, width: 24 }} />
                            </div>} </button>
                      ) : (
                        <div onClick={() => getuserlocationlist()}>
                          <div className={`border rounded d-flex p-2`}>
                            <div className="col-2 ">
                              <div className="border w-100 border-black border-opacity-10 rounded d-flex justify-content-center mt-2 fs-24 primary-text py-2">
                                {data?.delivery_details.location_type_id == 1 ? (
                                  <IoMdHome className="primary-text" />
                                ) : data?.delivery_details.location_type_id == 2 ? (
                                  <MdWork className="primary-text" />
                                ) : (
                                  <IoLocationSharp />
                                )}
                              </div>
                            </div>
                            <div className="col-9">
                              <p className="m-0 ps-3 ff-poppins-bold">
                                {data?.delivery_details.location_type}{" "}
                              </p>
                              <p className="m-0 ps-3 ff-poppins-regular singleline-text fs-12">
                                {data?.delivery_details.address}
                              </p>
                              <p className="m-0 ps-3 ff-poppins-regular fs-12">
                                {data?.delivery_details.distance?.text} - {data?.delivery_details.duration?.text}
                              </p>
                            </div>
                            <div className="col-1 ms-2 mt-3">
                              <IoIosArrowForward />
                            </div>
                          </div>
                        </div>
                      )}

                    </div>
                  ) :
                    <></>
                  }
                  {
                    data?.ticket_id ?
                      <>
                        <div className="p-2 ">
                          <h6 className="ff-poppins-bold s m-0 py-2">Food Ticket</h6>
                          {
                            data?.ticket_type == 1 ?

                              <KitchenProductTicket
                                item={data.ticket}
                                buynow={'false'}
                                fromPage={'reviewpay'}
                                quantity={ticketCartQuantity}
                                isQuantityUpdating={isTicketQuantityUpdating}
                                onQuantityChange={updateTicketCartQuantity}
                              /> :
                              data?.ticket_type == 2 ?
                                <KitchenComboTicket
                                  item={data.ticket}
                                  buynow={'false'}
                                  fromPage={'reviewpay'}
                                  quantity={ticketCartQuantity}
                                  isQuantityUpdating={isTicketQuantityUpdating}
                                  onQuantityChange={updateTicketCartQuantity}
                                /> : ""
                          }
                          {/* // <Kitchen_ticket Data={data.ticket} fromPage={'reviewpay'} /> */}
                        </div>

                      </> :
                      <>
                        <h6 className="ff-poppins-bold m-0 py-2">Membership Ticket</h6>
                        {/* <Kitchen_membership_card Data={data.ticket} fromPage={'reviewpay'} /> */}
                        <KitchenMembershipdetailCard item={data.ticket} />
                      </>
                  }
                  {flowtype == 'kitchenMemberShip' && data?.start_date ? (() => {
                    const [y, m, d] = data.start_date.split('-').map(Number);
                    const startDate = new Date(y, m - 1, d).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
                    return (
                      <div className="mt-3">
                        <h6 className="ff-poppins-semiBold p-0 m-0">Membership Information</h6>
                        <div className="d-flex justify-content-between align-items-center border rounded p-2 mt-2">
                          <span className="fs-12 secondary-text">Start Date</span>
                          <span className="ff-poppins-semiBold fs-12">{startDate}</span>
                        </div>
                      </div>
                    );
                  })() : null}
                  {flowtype == 'kitchenMemberShip' && data?.carrier_option == 1 && (
                    <div className="mt-3">
                      <h6 className="ff-poppins-semiBold p-0 m-0">Carrier Option</h6>
                      <div
                        onClick={toggleCarrier}
                        role="button"
                        className="d-flex justify-content-between align-items-center border rounded p-2 mt-2"
                        style={{ borderColor: data?.carrier_selected == 1 ? "#4E26A3" : undefined, opacity: carrierUpdating ? 0.6 : 1 }}
                      >
                        <div className="d-flex align-items-center">
                          <input type="checkbox" className="form-check-input m-0 me-2" checked={data?.carrier_selected == 1} readOnly />
                          <div>
                            <p className="m-0 ff-poppins-medium fs-13">Tiffin carrier</p>
                            <p className="m-0 fs-11 ff-poppins-regular secondary-text">One time charge added to your bill</p>
                          </div>
                        </div>
                        <span className="ff-poppins-semiBold fs-13">₹{data?.carrier_charge}</span>
                      </div>
                    </div>
                  )}
                  <div className="mt-3">
                    <h6 className="ff-poppins-semiBold p-0 m-0">Payment method</h6>
                    <div onClick={() => { setSelectPaytype(1); setWalletError(false); }} className="d-flex justify-content-between p-0 mt-2">
                      <div>
                        <p className="mb-0 ff-poppins-semiBold fs-14"> Pay Full </p>
                        <p className="fs-11 ff-poppins-semiBold secondary-text">Pay total amount now</p>
                      </div>
                      {selectpaytype == 1 ? (
                        <img src={tick_icon} height="20px" width="20px" />
                      ) : (
                        <MdOutlineRadioButtonUnchecked size={20} />
                      )}
                    </div>

                    <div
                      onClick={() => {
                        if (data?.otherPaymentOptions?.walletBalence >= data?.total) {
                          setSelectPaytype(5);
                          setWalletError(false); // clear error
                        } else {
                          setWalletError(true); // 🔥 trigger highlight
                        }
                      }}
                      className={`d-flex justify-content-between p-0 mt-2  ${data?.otherPaymentOptions?.walletBalence < data?.total ? 'opacity-40' : ''}   `}      >
                      <div>
                        <p className="mb-0 ff-poppins-semiBold fs-14">Wallet Payment</p>
                        <p className="fs-11 ff-poppins-semiBold secondary-text">
                          Current balance : {data?.otherPaymentOptions?.walletBalence}
                        </p>
                      </div>

                      {selectpaytype === 5 ? (
                        <img src={tick_icon} height="20px" width="20px" />
                      ) : (
                        <MdOutlineRadioButtonUnchecked size={20} />
                      )}
                    </div>

                    {data?.otherPaymentOptions?.walletBalence < data?.total &&
                      <div className={`wallet_insufficent_container ${walletError ? 'wallet_error_border' : ''}`}>
                        <p className="mb-0 ff-poppins-semiBold fs-10 text-danger">Insufficient Balance </p>
                        <button className="wallet_topup_btn" onClick={() => toggleOffcanvas()}  >
                          Add Money
                        </button>
                      </div>
                    }


                  </div>


                  <div className="d-flex justify-content-between align-items-center mt-2 h-100 cursor-pointer" onClick={toggleContent}>
                    <h6 className="bookInfoTextRP ff-poppins-semiBold mb-0">
                      Billing Information
                    </h6>

                    <span className="d-flex align-items-center">
                      {showContent ? (
                        <SlArrowUp size={16} />
                      ) : (
                        <SlArrowDown size={16} />
                      )}
                    </span>
                  </div>

                  {showContent && (
                    <div className="ff-poppins-regular fs-11">
                      Booking Initiated at {" "}
                      {new Date(data?.initiate).toLocaleString("en-US", { hour: "numeric", minute: "2-digit", hour12: true, month: "long", day: "numeric", year: "numeric", })}{" "}
                    </div>
                  )}


                  <h6 className="ff-poppins-semiBold primary-text fs-15 mt-3">
                    Ticket details
                  </h6>

                  <div>
                    <div className="d-flex justify-content-between">
                      <h6 className="p-0 m-0 fs-13 text-dark ff-poppins-regular ">
                        {data?.ticket?.ticket_name
                          ?.toLowerCase()
                          .replace(/\b\w/g, (char) => char.toUpperCase())}
                      </h6>
                      <p className="p-0 m-0 fs-13 text-dark ff-poppins-regular "> {data?.ticket?.discounted_quantity !== undefined
                        ? [
                          data.ticket.discounted_quantity > 0 ? `${data.ticket.discounted_quantity} x ${data.ticket.discount}` : null,
                          data.ticket.normal_quantity > 0 ? `${data.ticket.normal_quantity} x ${data.ticket.ticket_price}` : null,
                        ].filter(Boolean).join(" + ")
                        : `${data?.quantity || data?.qty || data?.ticket_quantity || 1} x ${data?.ticket?.discount ?? data?.ticket?.ticket_price}`} </p>
                    </div>

                    {flowtype == 'kitchenMemberShip' && (
                      <div className="price fs-12 ff-poppins-medium ">
                        (<span className="rupeeIcon ">₹</span>{data?.ticket?.ticket_price} / {data?.ticket?.validity_count_days}
                        {data?.ticket?.membership_validity_type == 0 ? ' Days' : ' Month'})
                      </div>
                    )}
                  </div>

                  <div className="ff-poppins-regular fs-12 mt-2 billing_info">
                    <div className="d-flex justify-content-between mt-3">
                      <p className="m-0">Subtotal</p>
                      <p className="m-0">{data.sub_total}</p>
                    </div>
                    {
                      flowtype == 'kitchenMemberShip' && data?.carrier_selected == 1 &&
                      <div className="d-flex justify-content-between mt-1">
                        <p className="m-0">Carrier Charge</p>
                        <p className="m-0">{data.carrier_charge}</p>
                      </div>
                    }



                    <div className="d-flex justify-content-between mt-1">
                      <p className="m-0">Platform Charges</p>
                      <p className="m-0">{data.platform_charge}</p>
                    </div>
                    {
                      data?.delivery_charges_status &&
                      <div className="d-flex justify-content-between mt-1">
                        <p className="m-0">Delivery Charge</p>
                        <p className="m-0">{data.delivery_charges_amount} </p>
                      </div>
                    }
                    {
                      data.round_off != 0 &&
                      <div className="d-flex justify-content-between mt-1">
                        <p className="m-0">Round Off</p>
                        <p className="m-0">{data.round_off}</p>
                      </div>
                    }
                    {
                      selectpaytype == 5 &&
                      <div className="d-flex justify-content-between mt-1 primary-text">
                        <p className="m-0">Wallet Pings</p>
                        <p className="m-0">- {data?.total}</p>
                      </div>
                    }
                    <div className="mb-3"></div>
                  </div>

                  <div className="d-flex justify-content-end align-items-center mt-2 mb-2 pb-1 border-Bottom-Dashed">
                    <div className="fs-14 ff-poppins-semiBold text-dark">Total -  {" "} </div>
                    <div className="fs-14 ff-poppins-semiBold text-dark">  {" "} Rs.{selectpaytype == 5 ? 0.00 : data.total}</div>
                  </div>

                  <div className="mt-2 mb-4">
                    <div className="p-2 bg-white rounded-4">
                      <h6 className=" ff-poppins-medium  fs-10"><span className="fs-11 ff-poppins-medium primary-text">Note :</span>  This booking may be cancelled with a refund subject to cancellation charges.</h6>
                    </div>
                  </div>
                </div>
              </div>



              <div className="product-paybtn-container ">
                <div className="offcanvas-body small">
                  {
                    showerrors &&
                    <span className="inline-error-text ">
                      Please select the delivery address to proceed
                    </span>
                  }

                  <button className="product-paybtn" disabled={isTicketQuantityUpdating} onClick={() => {
                    if (data?.shipping_type == 2 && data?.delivery_status == 0) {
                      setShowErrors(true)
                    } else {
                      confirmPayment();
                    }
                  }}>
                    {isLoading ? (
                      <>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"  ></span>
                        <span className="visually-hidden">Loading...</span>
                      </>
                    ) : (
                      selectpaytype == 5 ?
                        'Pay With Wallet' :
                        `Pay ₹${data.total}`
                    )}
                  </button>
                </div>
              </div>
              <div className={`offcanvas offcanvas-bottom Chooseaddres main }`}
                tabIndex="-1" id="selectLocatinModal" aria-labelledby="offcanvasBottomLabel"
                data-bs-backdrop="false" ref={locationModalRef} style={{ maxHeight: 'max-content', zIndex: 1045 }}>

                <div className="offcanvas-body small bg-light position-relative d-flex flex-column gap-3">
                  <div className="d-flex justify-content-between">
                    <div className="ff-poppins-semiBold"> Choose address </div>
                    <div onClick={() => closeLocationlistModal()}>
                      <CgCloseO />
                    </div>
                  </div>

                  <div style={{}} className="d-flex flex-column gap-3 scroller-style-y">
                    {userLocation.map((location, index) => {
                      return (
                        <div onClick={() => location.select_status ? select_Location(location.latlng) : ""} className="border-container px-2 py-2" >
                          <div className="d-flex align-items-center" style={{ opacity: location.select_status == 0 ? 0.4 : 1 }}  >
                            <div className="col-2">
                              <div className="border w-100 border-black border-opacity-10 rounded d-flex justify-content-center fs-24 primary-text py-2">
                                {location.location_type_id == 1 ? (
                                  <IoMdHome className="primary-text" />
                                ) : location.location_type_id == 2 ? (
                                  <MdWork className="primary-text" />
                                ) : (
                                  <IoLocationSharp />
                                )}
                              </div>
                            </div>
                            <div className="col-9">
                              <p className="m-0 ps-3 ff-poppins-bold">
                                {location.location_type}{" "}
                              </p>
                              <p className="m-0 ps-3 ff-poppins-regular fs-12">
                                {
                                  location.address.length > 30
                                    ? `${location.address.slice(0, 38)}...`
                                    : location.address

                                }
                                <span className="ms-2">  {location?.distance?.text} - {location?.duration?.text}</span>
                              </p>

                            </div>
                            <div className="col-1">
                              <IoIosArrowForward />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>


                  <div onClick={() => { navigate("/AddDeliveryAddress", { state: { fromPage: 'kitchenReview' } }); }} className="border-container px-2 py-2">
                    <div className="d-flex align-items-center">
                      <div className="col-2">
                        <div className="w-100  d-flex justify-content-center fs-24 primary-text py-2">
                          <FaRegSquarePlus />
                        </div>
                      </div>
                      <div className="col-9">
                        <p className="m-0 ps-3 ff-poppins-bold primary-text">Add New Address</p>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              {isOpen &&
                <AddPingsOffcanvas toggleOffcanvas={toggleOffcanvas} isOpen={isOpen} />
              }
            </div >

          </>
          :
          <div className="skeleton-bg">

            <Skeleton height={80} borderRadius={12} style={{ marginBottom: '10px' }} />
            <Skeleton height={80} borderRadius={12} style={{ marginBottom: '10px' }} />
            <Skeleton height={80} borderRadius={12} style={{ marginBottom: '10px' }} />
            <Skeleton height={80} borderRadius={12} style={{ marginBottom: '10px' }} />
            <Skeleton height={80} borderRadius={12} style={{ marginBottom: '10px' }} />
            <Skeleton height={80} borderRadius={12} style={{ marginBottom: '10px' }} />

          </div>
      }



      {/* <div className="modal fade " aria-labelledby="exampleModalLabel" aria-hidden="true" ref={paymentSuccessModalRef} style={{ backgroundColor: "#ebebeb", zIndex: "6666" }}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content modal-success ff-poppins-semiBold rounded-4" style={{ width: '80%' }}>
            <div className="  d-flex justify-content-center align-items-center">
              <Lottie animationData={SuccessLotie} loop={1} autoPlay={true} />
            </div>
            <div className="mt-1 text-center fw-bold primary-text">
              Payment Success.
            </div>
            <div className="text-center mb-3">
              <div className="  fw-bold">
                Redirecting you to your ticket.
              </div>
              <button type="button" className="btn col-4 mt-2 text-white rounded-4 fs-14 ff-poppins-regular primary-bg lottie_ok_btn" onClick={() => handleOkClick()}>
                OK
              </button>

            </div>
          </div>
        </div>
      </div> */}

      {
        paymentSuccess && (
          <div className="modal show d-flex justify-content-center" style={{ backgroundColor: "#ebebeb", zIndex: "6666" }}>
            <div className="modal-dialog modal-dialog-centered mainModal">
              <div className="modal-content  rounded-4" style={{ width: '70%' }}>
                <div className="d-flex justify-content-center align-items-center" style={{ height: "270px", width: "100%" }} >
                  <Lottie animationData={SuccessLotie} loop={1} autoPlay={true} style={{ width: "250px", height: "250px" }} />
                </div>
                <div className="ff-poppins-medium fs-14 text-center">
                  <div className="text-center fw-bold primary-text">
                    Payment Successful.
                  </div>
                  <button type="button" className="paymentSuccessOkBtn mt-4" onClick={() => navigate('/')} >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

      {isModalOpen && <div className="modal-backdrop fade show"></div>}

    </>
  );
};

export default Kitchen_ReviewPay;


